// import React, { useEffect, useMemo, useState } from "react";
// import { Typography, Select, Button, Card, Divider, Pagination } from "antd";
// import { FilterOutlined, DownOutlined } from "@ant-design/icons";
// import { useLocation, useNavigate } from "react-router-dom";
// import LeadCard from "./LeadCard";
// import PriorityLeadCard from "./PriorityLeadCard";
// import StatisticsChart from "./StatisticsChart";
// import "./newDashboard.css";
// import useLeadOptions from "../../components/NewDashboard/UseLeadOptions";
// import useBusinessDashboardApi from "../../hooks/useBusinessDashboardApi";
// import { formatAmountIndian } from "./FormatAmount";

// const { Title, Text } = Typography;

// export default function MyLeadsBusinessRetailMobile() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   /* ---------------- STATE ---------------- */
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [statusFilter, setStatusFilter] = useState("qualified");
//   // const [localStatusMap, setLocalStatusMap] = useState({});

//   const [filters, setFilters] = useState({
//     location: [],
//     landType: [],
//     budget: [],
//     plotSize: [],
//   });

//   /* ---------------- API HOOK ---------------- */
//   const {
//     allLeads,
//     pagination,
//     cartLeads,
//     myRetailLeads,
//     retailPagination,
//     fetchMyRetailLeads,
//     fetchAllLeads,
//     updateLeadStatus,
//     addLeadToCart,
//     removeLeadFromCart,
//   } = useBusinessDashboardApi();

//   /* ---------------- NAV FILTER SUPPORT ---------------- */
//   useEffect(() => {
//     if (location.state?.filters) {
//       const f = location.state.filters;
//       setFilters({
//         location: f.location || [],
//         landType: f.landType || [],
//         budget: f.budget || [],
//         plotSize: f.plotSize || [],
//       });
//     }
//   }, [location.state]);

//   /* ---------------- NORMALIZE LEADS ---------------- */
//   const leads = useMemo(() => {
//     return (Array.isArray(myRetailLeads) ? myRetailLeads : []).map((lead) => ({
//       id: lead._id,
//       name: lead.name,
//       place: lead.location,
//       price: lead.budget,
//       currentRate: lead.currentRate,
//       landType: lead.subcategory?.label || "",
//       rating: `${lead.timesBought || 0}/${lead.leadAvailableCount || 0}`,
//       user_status: lead.user_status || "",
//       // user_status: localStatusMap[lead._id] ?? lead.user_status ?? "",
//       lookingFor: lead.property_details || "",
//       contact: lead.phone,
//       type: lead.leadType,
//       state: lead.state || "",
//       district: lead.district || "",
//       area: lead.area || "",
//       pincode: lead.pincode || "",
//       sqft: lead.spaceSqft || 0,
//       siteVisit: lead.siteVisitDays?.join(", ") || "",
//       purpose: lead.purpose || "",
//     }));
//   }, [myRetailLeads]);

//   /* ---------------- OPTIONS ---------------- */
//   const { locationOptions, landTypeOptions, budgetOptions, plotSizeOptions } =
//     useLeadOptions(leads);

//   const statusOptions = [
//     { label: "Qualified", value: "qualified" },
//     { label: "RNR", value: "rnr" },
//     { label: "Intake", value: "intake" },
//     { label: "Disqualified", value: "disqualified" },
//   ];

//   /* ---------------- FILTERED LEADS ---------------- */
//   const filteredLeads = leads.filter((lead) => {
//     return (
//       (!filters.location.length || filters.location.includes(lead.place)) &&
//       (!filters.landType.length || filters.landType.includes(lead.landType)) &&
//       (!filters.budget.length ||
//         filters.budget.some((b) => Number(lead.price) <= Number(b))) &&
//       (!filters.plotSize.length ||
//         filters.plotSize.some((s) => Number(lead.sqft) >= Number(s)))
//     );
//   });

//   /* ---------------- PRIORITY LEAD ---------------- */
//   const priorityLead = filteredLeads.find((lead) => {
//     const [purchased, total] = lead.rating.split("/").map(Number);
//     return total - purchased === 1;
//   });

//   /* ---------------- STATUS GROUPING ---------------- */
//   const leadsByStatus = useMemo(() => {
//     return {
//       qualified: leads.filter((l) => l.user_status === "qualified"),
//       rnr: leads.filter((l) => l.user_status === "rnr"),
//       intake: leads.filter((l) => l.user_status === "intake"),
//       disqualified: leads.filter((l) => l.user_status === "disqualified"),
//     };
//   }, [leads]);

//   const leadsToRender = filteredLeads;

//   const finalMyLeads = React.useMemo(() => {
//     return filteredLeads.filter((lead) => lead.purpose === "BUILD");
//   }, [filteredLeads]);

//   const bottomLeads = leadsByStatus[statusFilter] || [];

//   return (
//     <div style={{ padding: 0, paddingBottom: 90 }}>
//       {/* ================= PRIORITY LEAD ================= */}
//       {/* {priorityLead && ( */}
//       <PriorityLeadCard
//         // name={priorityLead.name}
//         // place={priorityLead.place}
//         // rating={priorityLead.rating}
//         onTopPickClick={(leadId) =>
//           navigate(`/user-dashboard?selectedleadid=${leadId}`)
//         }
//       />
//       {/* )} */}

//       {/* ================= ALL LEADS ================= */}
//       <Title level={4} style={{ marginTop: 16 }}>
//         My Retail Leads
//       </Title>

//       <div style={{ background: "#fff", padding: 6 }}>
//         {filteredLeads.map((lead) => (
//           <div key={lead.id}>
//             <LeadCard
//               {...lead}
//               showCartIcon={false}
//               onClick={() =>
//                 setSelectedLead(selectedLead?.id === lead.id ? null : lead)
//               }
//             />

//             {/* ===== INLINE DETAILS ===== */}
//             {selectedLead?.id === lead.id && (
//               <Card style={{ background: "#fafafa", marginTop: 8 }}>
//                 {/* <div
//                   style={{ display: "flex", justifyContent: "space-between" }}
//                 > */}
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "flex-end",
//                   }}
//                 >
//                   <Text strong style={{ marginBottom: 4 }}>
//                     Update Lead
//                   </Text>
//                   {/* STATUS UPDATE */}
//                   <Select
//                     className="custom-select"
//                     placeholder="Update Status"
//                     value={selectedLead.user_status}
//                     options={statusOptions}
//                     style={{
//                       border: "1px solid #DBEAFF",
//                       borderRadius: 6,
//                       background: "#fff",
//                       width: "55%",
//                       minWidth: 140,
//                     }}
//                     onChange={(value) => {
//                       updateLeadStatus(lead.id, value);
//                       setSelectedLead((prev) => ({
//                         ...prev,
//                         user_status: value,
//                       }));
//                     }}
//                   />
//                 </div>

//                 {/* </div> */}
//                 <Text strong>Lead Details</Text>
//                 <Divider style={{ margin: "6px 0" }} />

//                 {/* GRID ROW 1 */}
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "1fr 1px 1fr",
//                     alignItems: "center",
//                   }}
//                 >
//                   <div style={{ padding: 6 }}>
//                     <strong>Name</strong>
//                     <div>{lead.name}</div>
//                   </div>

//                   <div
//                     style={{ width: 1, height: "100%", background: "#DBEAFF" }}
//                   />

//                   <div style={{ padding: 6 }}>
//                     <strong>Contact No.</strong>
//                     <div>{lead.contact || "-"}</div>
//                   </div>
//                 </div>

//                 <Divider style={{ margin: "6px 0" }} />

//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "1fr 1px 1fr",
//                     alignItems: "center",
//                   }}
//                 >
//                   <div style={{ padding: 6 }}>
//                     <strong>Client Location</strong>
//                     <div>{lead.place}</div>
//                   </div>

//                   <div
//                     style={{ width: 1, height: "100%", background: "#DBEAFF" }}
//                   />

//                   <div style={{ padding: 6 }}>
//                     <strong>Sq.ft</strong>
//                     <div>{lead.sqft}</div>
//                   </div>
//                 </div>

//                 <Divider style={{ margin: "6px 0" }} />

//                 {/* GRID ROW 3 */}
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "1fr 1px 1fr",
//                     alignItems: "center",
//                   }}
//                 >
//                   <div style={{ padding: 6 }}>
//                     <strong>Budget</strong>
//                     <div>₹ {formatAmountIndian(lead.price)}</div>
//                   </div>

//                   <div
//                     style={{ width: 1, height: "100%", background: "#DBEAFF" }}
//                   />

//                   <div style={{ padding: 6 }}>
//                     <strong>Preferred location</strong>
//                     <p>
//                       {lead?.state || ""}-{lead?.district || ""}-
//                       {lead?.area || ""}--
//                       {lead?.pincode || ""}
//                     </p>
//                   </div>
//                 </div>

//                 <Divider style={{ margin: "6px 0" }} />

//                 {/* GRID ROW 4 */}
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "1fr 1px 1fr",
//                     alignItems: "center",
//                   }}
//                 >
//                   <div style={{ padding: 6 }}>
//                     <strong>Site Visit</strong>
//                     <div>{lead.siteVisit}</div>
//                   </div>

//                   <div
//                     style={{ width: 1, height: "100%", background: "#DBEAFF" }}
//                   />

//                   <div style={{ padding: 6 }}>
//                     <strong>Looking For</strong>
//                     <div>{lead.lookingFor}</div>
//                   </div>
//                 </div>
//               </Card>
//             )}
//           </div>
//         ))}
//       </div>

//       <Pagination
//         simple
//         showSizeChanger={false}
//         current={retailPagination.currentPage}
//         total={retailPagination.total || 10}
//         pageSize={retailPagination.perPage}
//         onChange={(page) => fetchMyRetailLeads(page)}
//         style={{ marginTop: 16, textAlign: "center" }}
//       />

//       {/* ================= CHART ================= */}
//       <Title level={5} style={{ marginTop: 16 }}>
//         Lead Statistics
//       </Title>

//       <Card>
//         <StatisticsChart />
//       </Card>

//       {/* ================= STATUS DROPDOWN (BOTTOM) ================= */}
//       <div style={{ marginTop: 16 }}>
//         <Title level={5} style={{ marginTop: 16 }}>
//           Lead Update
//         </Title>
//         <Select
//           value={statusFilter}
//           bordered={false}
//           suffixIcon={<DownOutlined />}
//           options={statusOptions}
//           onChange={setStatusFilter}
//           style={{
//             border: "1px solid #DBEAFF",
//             borderRadius: 6,
//             background: "#fff",
//             width: "100%",
//           }}
//         />
//       </div>

//       <Card style={{ marginTop: 8 }}>
//         {bottomLeads.map((lead) => (
//           <LeadCard
//             key={lead.id}
//             {...lead}
//             showCheckbox={false}
//             showCartIcon={false}
//             onClick={() => setSelectedLead(lead)}
//           />
//         ))}
//       </Card>
//     </div>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import { Typography, Select, Button, Card, Divider, Pagination, Modal, Input, message } from "antd";
import { FilterOutlined, DownOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import LeadCard from "./LeadCard";
import PriorityLeadCard from "./PriorityLeadCard";
import StatisticsChart from "./StatisticsChart";
import "./newDashboard.css";
import useLeadOptions from "../../components/NewDashboard/UseLeadOptions";
import useBusinessDashboardApi from "../../hooks/useBusinessDashboardApi";
import axiosNew from "../../store/api/axiosNew";
import { formatAmountIndian } from "./FormatAmount";

const { Title, Text } = Typography;
const { TextArea } = Input;

export default function MyLeadsBusinessRetailMobile() {
  const navigate = useNavigate();
  const location = useLocation();

  /* ---------------- STATE ---------------- */
  const [selectedLead, setSelectedLead] = useState(null);
  const [statusFilter, setStatusFilter] = useState("qualified");

  // Modal & Feedback States
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [feedbackReason, setFeedbackReason] = useState("");
  const [pendingStatus, setPendingStatus] = useState(null);
  const [pendingLeadId, setPendingLeadId] = useState(null);
  const [submittingFeedback, setSubmittingFeedback] = useState(false);

  const [filters, setFilters] = useState({
    location: [],
    landType: [],
    budget: [],
    plotSize: [],
  });

  /* ---------------- API HOOK ---------------- */
  const {
    allLeads,
    pagination,
    cartLeads,
    myRetailLeads,
    retailPagination,
    fetchMyRetailLeads,
    fetchAllLeads,
    updateLeadStatus,
    addLeadToCart,
    removeLeadFromCart,
  } = useBusinessDashboardApi();

  /* ---------------- NAV FILTER SUPPORT ---------------- */
  useEffect(() => {
    if (location.state?.filters) {
      const f = location.state.filters;
      setFilters({
        location: f.location || [],
        landType: f.landType || [],
        budget: f.budget || [],
        plotSize: f.plotSize || [],
      });
    }
  }, [location.state]);

  /* ---------------- NORMALIZE LEADS ---------------- */
  const leads = useMemo(() => {
    return (Array.isArray(myRetailLeads) ? myRetailLeads : []).map((lead) => ({
      id: lead._id,
      name: lead.name,
      place: lead.location,
      price: lead.budget,
      currentRate: lead.currentRate,
      landType: lead.subcategory?.label || "",
      rating: `${lead.timesBought || 0}/${lead.leadAvailableCount || 0}`,
      user_status: lead.user_status || "",
      lookingFor: lead.property_details || "",
      contact: lead.phone,
      type: lead.leadType,
      state: lead.state || "",
      district: lead.district || "",
      area: lead.area || "",
      pincode: lead.pincode || "",
      sqft: lead.spaceSqft || 0,
      siteVisit: lead.siteVisitDays?.join(", ") || "",
      purpose: lead.purpose || "",
    }));
  }, [myRetailLeads]);

  /* ---------------- OPTIONS ---------------- */
  const { locationOptions, landTypeOptions, budgetOptions, plotSizeOptions } =
    useLeadOptions(leads);

  const statusOptions = [
    { label: "Qualified", value: "qualified" },
    { label: "RNR", value: "rnr" },
    { label: "Intake", value: "intake" },
    { label: "Disqualified", value: "disqualified" },
  ];

  /* ---------------- FILTERED LEADS ---------------- */
  const filteredLeads = leads.filter((lead) => {
    return (
      (!filters.location.length || filters.location.includes(lead.place)) &&
      (!filters.landType.length || filters.landType.includes(lead.landType)) &&
      (!filters.budget.length ||
        filters.budget.some((b) => Number(lead.price) <= Number(b))) &&
      (!filters.plotSize.length ||
        filters.plotSize.some((s) => Number(lead.sqft) >= Number(s)))
    );
  });

  /* ---------------- PRIORITY LEAD ---------------- */
  const priorityLead = filteredLeads.find((lead) => {
    const [purchased, total] = lead.rating.split("/").map(Number);
    return total - purchased === 1;
  });

  /* ---------------- STATUS GROUPING ---------------- */
  const leadsByStatus = useMemo(() => {
    return {
      qualified: leads.filter((l) => l.user_status === "qualified"),
      rnr: leads.filter((l) => l.user_status === "rnr"),
      intake: leads.filter((l) => l.user_status === "intake"),
      disqualified: leads.filter((l) => l.user_status === "disqualified"),
    };
  }, [leads]);

  const bottomLeads = leadsByStatus[statusFilter] || [];

  /* ---------------- STATUS CHANGE LOGIC ---------------- */
  // const handleStatusChange = (leadId, selectedValue) => {
  //   if (selectedValue === "disqualified") {
  //     setPendingStatus(selectedValue);
  //     setPendingLeadId(leadId);
  //     setIsFeedbackModalOpen(true);
  //   } else {
  //     applyStatusUpdate(leadId, selectedValue);
  //   }
  // };

  // const applyStatusUpdate = (leadId, status) => {
  //   updateLeadStatus(leadId, status);
  //   setSelectedLead((prev) =>
  //     prev?.id === leadId ? { ...prev, user_status: status } : prev
  //   );
  // };

  // Updated Mobile handleFeedbackSubmit
// const handleFeedbackSubmit = async () => {
//   if (!feedbackReason.trim()) {
//     message.error("Please enter a reason for disqualification.");
//     return;
//   }

//   try {
//     setSubmittingFeedback(true);

//     // Call applyStatusUpdate with lead ID, status, and feedback payload
//     // Adjust signature if mobile's applyStatusUpdate expects (leadId, status, extraData)
//     await applyStatusUpdate(pendingLeadId, pendingStatus, {
//       disqualifiedReason: feedbackReason,
//     });

//     message.success("Feedback submitted successfully");

//     // Reset modal state
//     handleModalCancel();
//   } catch (error) {
//     console.error("Error submitting feedback:", error);
//     message.error("Failed to submit feedback. Please try again.");
//   } finally {
//     setSubmittingFeedback(false);
//   }
// };

//   const handleModalCancel = () => {
//     setIsFeedbackModalOpen(false);
//     setFeedbackReason("");
//     setPendingStatus(null);
//     setPendingLeadId(null);
//   };

/* ---------------- STATUS CHANGE LOGIC ---------------- */
  const handleStatusChange = (leadId, selectedValue) => {
    if (selectedValue === "disqualified") {
      setPendingStatus(selectedValue);
      setPendingLeadId(leadId);
      setIsFeedbackModalOpen(true);
    } else {
      applyStatusUpdate(leadId, selectedValue);
    }
  };

  const applyStatusUpdate = async (leadId, status, extraData = {}) => {
    try {
      const extraPayload =
        typeof extraData === "string"
          ? { disqualifiedReason: extraData }
          : extraData;

      // Pass leadId, status, AND extraPayload (disqualifiedReason) to API custom hook
      await updateLeadStatus(leadId, status, extraPayload);

      setSelectedLead((prev) =>
        prev?.id === leadId ? { ...prev, user_status: status } : prev
      );
    } catch (err) {
      console.error("Failed to update status:", err);
      throw err; // Re-throw so handleFeedbackSubmit's catch block triggers
    }
  };

  const handleModalCancel = () => {
    setIsFeedbackModalOpen(false);
    setFeedbackReason("");
    setPendingStatus(null);
    setPendingLeadId(null);
  };

  // Mobile handleFeedbackSubmit
  const handleFeedbackSubmit = async () => {
    if (!feedbackReason.trim()) {
      message.error("Please enter a reason for disqualification.");
      return;
    }

    try {
      setSubmittingFeedback(true);

      // Submit status update with feedback reason
      await applyStatusUpdate(pendingLeadId, pendingStatus, {
        disqualifiedReason: feedbackReason,
      });

      message.success("Feedback submitted successfully");

      // Reset modal state
      handleModalCancel();
    } catch (error) {
      console.error("Error submitting feedback:", error);
      message.error("Failed to submit feedback. Please try again.");
    } finally {
      setSubmittingFeedback(false);
    }
  };

  return (
    <div style={{ padding: 0, paddingBottom: 90 }}>
      {/* ================= PRIORITY LEAD ================= */}
      <PriorityLeadCard
        onTopPickClick={(leadId) =>
          navigate(`/user-dashboard?selectedleadid=${leadId}`)
        }
      />

      {/* ================= ALL LEADS ================= */}
      <Title level={4} style={{ marginTop: 16 }}>
        My Retail Leads
      </Title>

      <div style={{ background: "#fff", padding: 6 }}>
        {filteredLeads.map((lead) => (
          <div key={lead.id}>
            <LeadCard
              {...lead}
              showCartIcon={false}
              onClick={() =>
                setSelectedLead(selectedLead?.id === lead.id ? null : lead)
              }
            />

            {/* ===== INLINE DETAILS ===== */}
            {selectedLead?.id === lead.id && (
              <Card style={{ background: "#fafafa", marginTop: 8 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                  }}
                >
                  <Text strong style={{ marginBottom: 4 }}>
                    Update Lead
                  </Text>
                  {/* STATUS UPDATE */}
                  <Select
                    className="custom-select"
                    placeholder="Update Status"
                    value={selectedLead.user_status}
                    options={statusOptions}
                    style={{
                      border: "1px solid #c3dbfc",
                      borderRadius: 6,
                      background: "#fff",
                      width: "55%",
                      minWidth: 140,
                    }}
                    onChange={(value) => handleStatusChange(lead.id, value)}
                  />
                </div>

                <Text strong>Lead Details</Text>
                <Divider style={{ margin: "6px 0" }} />

                {/* GRID ROW 1 */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1px 1fr",
                    alignItems: "center",
                  }}
                >
                  <div style={{ padding: 6 }}>
                    <strong>Name</strong>
                    <div>{lead.name}</div>
                  </div>

                  <div
                    style={{ width: 1, height: "100%", background: "#DBEAFF" }}
                  />

                  <div style={{ padding: 6 }}>
                    <strong>Contact No.</strong>
                    <div>{lead.contact || "-"}</div>
                  </div>
                </div>

                <Divider style={{ margin: "6px 0" }} />

                {/* GRID ROW 2 */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1px 1fr",
                    alignItems: "center",
                  }}
                >
                  <div style={{ padding: 6 }}>
                    <strong>Client Location</strong>
                    <div>{lead.place}</div>
                  </div>

                  <div
                    style={{ width: 1, height: "100%", background: "#DBEAFF" }}
                  />

                  <div style={{ padding: 6 }}>
                    <strong>Sq.ft</strong>
                    <div>{lead.sqft}</div>
                  </div>
                </div>

                <Divider style={{ margin: "6px 0" }} />

                {/* GRID ROW 3 */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1px 1fr",
                    alignItems: "center",
                  }}
                >
                  <div style={{ padding: 6 }}>
                    <strong>Budget</strong>
                    <div>₹ {formatAmountIndian(lead.price)}</div>
                  </div>

                  <div
                    style={{ width: 1, height: "100%", background: "#DBEAFF" }}
                  />

                  <div style={{ padding: 6 }}>
                    <strong>Preferred location</strong>
                    <p>
                      {lead?.state || ""}-{lead?.district || ""}-
                      {lead?.area || ""}--
                      {lead?.pincode || ""}
                    </p>
                  </div>
                </div>

                <Divider style={{ margin: "6px 0" }} />

                {/* GRID ROW 4 */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1px 1fr",
                    alignItems: "center",
                  }}
                >
                  <div style={{ padding: 6 }}>
                    <strong>Site Visit</strong>
                    <div>{lead.siteVisit}</div>
                  </div>

                  <div
                    style={{ width: 1, height: "100%", background: "#DBEAFF" }}
                  />

                  <div style={{ padding: 6 }}>
                    <strong>Looking For</strong>
                    <div>{lead.lookingFor}</div>
                  </div>
                </div>
              </Card>
            )}
          </div>
        ))}
      </div>

      <Pagination
        simple
        showSizeChanger={false}
        current={retailPagination.currentPage}
        total={retailPagination.total || 10}
        pageSize={retailPagination.perPage}
        onChange={(page) => fetchMyRetailLeads(page)}
        style={{ marginTop: 16, textAlign: "center" }}
      />

      {/* ================= CHART ================= */}
      <Title level={5} style={{ marginTop: 16 }}>
        Lead Statistics
      </Title>

      <Card>
        <StatisticsChart />
      </Card>

      {/* ================= STATUS DROPDOWN (BOTTOM) ================= */}
      <div style={{ marginTop: 16 }}>
        <Title level={5} style={{ marginTop: 16 }}>
          Lead Update
        </Title>
        <Select
          value={statusFilter}
          bordered={false}
          suffixIcon={<DownOutlined />}
          options={statusOptions}
          onChange={setStatusFilter}
          style={{
            border: "1px solid #DBEAFF",
            borderRadius: 6,
            background: "#fff",
            width: "100%",
          }}
        />
      </div>

      <Card style={{ marginTop: 8 }}>
        {bottomLeads.map((lead) => (
          <LeadCard
            key={lead.id}
            {...lead}
            showCheckbox={false}
            showCartIcon={false}
            onClick={() => setSelectedLead(lead)}
          />
        ))}
      </Card>

      {/* ================= DISQUALIFICATION FEEDBACK MODAL ================= */}
      <Modal
        title="Disqualification Feedback"
        open={isFeedbackModalOpen}
        onCancel={handleModalCancel}
        style={{
          maxWidth: "calc(100vw - 32px)",
          margin: "0 auto",
        }}
        bodyStyle={{
          padding: "16px 8px",
        }}
        footer={[
          <Button key="cancel" onClick={handleModalCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={submittingFeedback}
            onClick={handleFeedbackSubmit}
          >
            Submit
          </Button>,
        ]}
      >
        <p style={{ marginBottom: 12 }}>
          Please provide a reason or feedback for marking this lead as disqualified:
        </p>
        <TextArea
          rows={4}
          placeholder="Enter reason or feedback..."
          value={feedbackReason}
          onChange={(e) => setFeedbackReason(e.target.value)}
        />
      </Modal>
    </div>
  );
}